import styled from "@emotion/styled";
import { useFetchAuth } from "hooks/queries/auth/authQueries";
import { useEffect } from "react";
export const Logout = () => {
  const { data: isAuth } = useFetchAuth();
  const urlParameter = window.document.referrer;
  const isEnglish = window.location.search === "?lang=en";

  useEffect(() => {
    if (!urlParameter) {
      window.location.href = process.env.ENERGYX_URL || "";
    } else {
      if (isEnglish) {
        const enPageRedirectUrl = `${process.env.ENERGYX_URL}/?lang=en`;
        window.location.href = `${process.env.API_URL}/sso/logout?redirectUrl=${enPageRedirectUrl}&continueUrl=${window.location.origin}`;
        return;
      }
      window.location.href = `${process.env.API_URL}/sso/logout?redirectUrl=${urlParameter}&continueUrl=${window.location.origin}`;
    }
  }, [urlParameter, isAuth]);

  return (
    <LoginContainer>
      <h1>잠시만 기다려주십시오…</h1>
    </LoginContainer>
  );
};

const LoginContainer = styled.section`
  position: absolute;
  left: 25px;
  top: 15px;
`;
